import { useAppTheme } from "@hooks/useAppTheme";
import Box from "@memorang/ui/src/components/Box";
import { Pressable } from "react-native";
/* -----------------UI--------------- */
import { Text } from "react-native-paper";
import { emailInstructionMessage } from "../constants/auth";

/* -----------------Child components--------------- */

type Props = {
	handleOpenSupport?: () => void;
	label: string;
	buttonText: string;
	disabled?: boolean;
	email: string;
};
const ContactSupport = (props: Props) => {
	const { handleOpenSupport, label, buttonText, disabled, email } = props;
	const theme = useAppTheme();
	return (
		<Box
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			paddingTop={16}
			gap={12}
		>
			<Box
				flexDirection="row"
				alignItems="center"
				justifyContent="center"
				gap={4}
			>
				<Text variant="bodyMedium">{label}</Text>
				<Pressable disabled={disabled} onPress={handleOpenSupport}>
					<Text
						variant="bodyMedium"
						style={{
							color: theme.colors.secondary,
						}}
					>
						{buttonText}
					</Text>
				</Pressable>
			</Box>
			<Text
				variant="bodySmall"
				style={{
					textAlign: "center",
					color: theme.colors.onSurfaceVariant,
				}}
			>
				{emailInstructionMessage(email)}
			</Text>
		</Box>
	);
};

export default ContactSupport;
